import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';

import { LoginStates } from './login.states';

import {LaddaModule} from 'angular2-ladda';
import {LoginShellComponent} from './login-shell.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '@edl-development/edl-common';
import { EdlAuthServicesModule, EdlCommonAuthenticationModule} from '@edl-development/edl-auth';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        UIRouterModule.forChild({
            states: LoginStates
        }),
        LaddaModule,
        ReactiveFormsModule,
        NgbModule,
        EdlAuthServicesModule,
        EdlCommonAuthenticationModule
    ],
    declarations: [
        LoginShellComponent,
    ],
    providers: [ AuthService ]
})
export class LoginModule {

}
